import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this.l12_1 = this;
        this.m12_1 = this;
        this.n12_1 = false;
      }
      o12(node, permissionsBitmask) {
        var prev = this.m12_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.b1m_1 & permissionsBitmask) === 0 && prev.o12(node, permissionsBitmask));
        } else {
          node.l12_1 = this;
          node.m12_1 = prev;
          prev.l12_1 = node;
          this.m12_1 = node;
          tmp = true;
        }
        return tmp;
      }
      d15(forbiddenElementsBit) {
        this.o12(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      p12() {
        if (this.n12_1)
          return false;
        var prev = this.m12_1;
        var next = this.l12_1;
        prev.l12_1 = next;
        next.m12_1 = prev;
        this.n12_1 = true;
        return true;
      }
      q12(node) {
        if (!(this.l12_1 === this))
          return false;
        this.o12(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.b1m_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
